import { useMemo } from 'react'
import { Box } from '@mui/material'
import { useAppSelector } from 'app/state'
import HeaderPopper from 'features/common/ui/AppTemplate/Header/Partials/HeaderPopper'
import OnboardingChecklistTrigger from './OnboardingChecklistTrigger'
import OnboardingChecklistHeader from './OnboardingChecklistHeader'
import OnboardingChecklistContent from './OnboardingChecklistContent'
import OnboardingChecklistFooter from './OnboardingChecklistFooter'
import OnboardingChecklistConfirmation from './OnboardingChecklistConfirmation'
import useOnboardingChecklist from 'features/onboarding-checklist/utils/useOnboardingChecklist'

export function OnboardingChecklist() {
  const { tasks, completed, open, showCompletionConfirmation } = useAppSelector((state) => state.onboardingChecklist)
  const total = tasks?.length || 0
  const { toggleOnboardingChecklist } = useOnboardingChecklist()

  const completedTasks = useMemo(() => tasks?.filter((task) => task.completed)?.length || 0, [tasks])

  if (!tasks) {
    return null
  }

  return (
    <HeaderPopper
      icon={<OnboardingChecklistTrigger completed={completed} completedTotal={completedTasks} total={total} />}
      open={open || false}
      handleOpen={() => toggleOnboardingChecklist()}
      handleClose={() => toggleOnboardingChecklist()}
      maxWidth={420}
      ariaLabelButton="Onboarding checklist panel"
    >
      {showCompletionConfirmation ? (
        <OnboardingChecklistConfirmation />
      ) : (
        <Box aria-label="onboarding-checklist">
          <OnboardingChecklistHeader completedTotal={completedTasks} total={total} />
          <OnboardingChecklistContent />
          <OnboardingChecklistFooter />
        </Box>
      )}
    </HeaderPopper>
  )
}

export default OnboardingChecklist
